import React from 'react'
import { useHover } from 'react-use'
import Tooltip from '../../atoms/Tooltip/Tooltip'

interface RemoveButtonProps {
  className?: string
  index?: number
  onRemove: (index?: number) => void
  /** When `true`, disables the button. When a string, disables it and shows the string as a tooltip on hover. */
  disabled?: boolean | string
}

const RemoveButton = ({ className, index, onRemove, disabled }: RemoveButtonProps) => {
  const [hoverableButton, isHovering] = useHover(
    <button type="button" className={className} onClick={() => !disabled && onRemove(index)} />,
  )

  return typeof disabled === 'string' ? (
    <Tooltip isOpen={isHovering} body={disabled}>
      {hoverableButton}
    </Tooltip>
  ) : (
    hoverableButton
  )
}

export default RemoveButton
